import { translations } from "../../../configs/translations"
import { useStore } from "../../../store/store"
import "./ShortTermAchievement.css"

interface ShortTermAchievementProps {
    title: string
    x: number
    animationKey: number
}

export const ShortTermAchievement = ({ title, x, animationKey }: ShortTermAchievementProps) => {
    const language = useStore(state => state.language) as keyof typeof translations
    const t = translations[language]


    return (
        <>
            {<ShortTermAchievementRace
                title={title}
                x={x}
                animationKey={animationKey}
            />}
        </>
    )
}

interface ShortTermAchievementRaceProps {
    title: string
    x: number
    animationKey: number
}

export const ShortTermAchievementRace = ({
    title,
    x,
    animationKey
}: ShortTermAchievementRaceProps) => {
    const language = useStore(state => state.language) as keyof typeof translations
    const t = translations[language]

    return (
        <>
            {title && (
                <div
                    key={`achievement-${animationKey}`}
                    className={`short-term-achievement short-term-achievement-x${x}`}
                >
                    <p>{t[title.toLowerCase() as keyof typeof t]}</p>
                </div>
            )}
        </>
    )
}